<script context="module">
    import DOMPurify from 'dompurify';

    export function clean(html) {
        return DOMPurify.sanitize(html);
    }
</script>